module.exports = __webpack_public_path__ + "static/stray_splash-adbabbffa3d5bd234498e95cbc88c876.png";